<template>
    <div class="jumbotron jumbotron-fluid jumbotron-home">
        <div class="jumbotron-home-insider jumbotron-home-insider-alt with-polygons">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-md-10 offset-md-1">
                        <h1 class="h1-forms">Rejestracja</h1>

                        <form id="f-register" method="post" @submit.prevent="handleRegisterForm()">
                            <div class="form-row">
                                <form-input v-model="name" :error-messages="errorMessages" :modelValue="name"
                                            label="Imię:" name="name"
                                            size="col-md-6"></form-input>
                                <form-input v-model="last_name" :error-messages="errorMessages" :modelValue="last_name"
                                            label="Nazwisko:"
                                            name="last_name" size="col-md-6"></form-input>
                            </div>
                            <form-input id="fr-email" v-model="email" :error-messages="errorMessages"
                                        :modelValue="email" label="E-mail:"
                                        name="email" type="email"></form-input>

                            <div class="form-row">
                                <form-input id="fr-pwd" v-model="password" :error-messages="errorMessages"
                                            :modelValue="password"
                                            extraInfo="Hasło musi składać się przynajmniej z 8 znaków."
                                            label="Hasło:" minlength="8" name="password"
                                            size="col-md-6"
                                            type="password"></form-input>
                                <form-input id="fr-pwdr" v-model="password_confirm" :error-messages="errorMessages"
                                            :modelValue="password_confirm" label="Powtórz hasło:" minlength="8"
                                            name="password_confirm" size="col-md-6"
                                            type="password"></form-input>
                            </div>

                            <div class="form-row">
                                <form-select v-model="profession" :error-messages="errorMessages"
                                             :modelValue="profession"
                                             :values="JSON.parse(professions)" label="Wykonywany zawód:"
                                             name="profession"
                                             size="col-md-6"></form-select>
                                <form-input
                                    v-if="profession != 3 && profession != 4 && profession != 6 && profession != 8 && profession != 9  && profession != 12  && profession != 13 && profession != 15 && profession != 16"
                                    id="fr-pwz" v-model="pwz_number"
                                    :error-messages="errorMessages" :modelValue="pwz_number"
                                    label="Podaj numer prawa wykonywania zawodu:" maxlength="15" name="pwz_number"
                                    size="col-md-6" type="text"></form-input>
                            </div>

                            <div v-if="profession != 4 && profession != 6" class="form-group">
                                <form-textarea v-model="work_place" :error-messages="errorMessages"
                                               :modelValue="work_place"
                                               label="Miejsce pracy:" name="work_place"
                                               rows="3"></form-textarea>
                            </div>

                            <div class="form-row">
                                <form-input id="fr-phon" v-model="phone" :error-messages="errorMessages"
                                            :modelValue="phone"
                                            label="Telefon:" maxlength="50" name="phone" size="col-md-6"
                                            type="text"></form-input>
                                <form-input v-if="profession == 1" id="fr-specs" v-model="specialization"
                                            :error-messages="errorMessages" :modelValue="specialization"
                                            label="Specjalizacja:" maxlength="100"
                                            name="specialization" size="col-md-6"
                                            type="text"></form-input>
                                <form-input v-if="profession == 4" v-model="university" :error-messages="errorMessages"
                                            :modelValue="university" label="Uniwersytet:" name="university"
                                            size="col-md-6"
                                            type="text"></form-input>
                                <form-input v-if="profession == 4" v-model="card"
                                            :error-messages="errorMessages" :modelValue="card"
                                            label="Podaj numer legitymacji studenckej" name="card" size="col-md-6"
                                            type="text"></form-input>
                                <form-input v-if="profession == 6" v-model="company_represented"
                                            :error-messages="errorMessages" :modelValue="company_represented"
                                            label="Podaj firmę, której jesteś przedstawicielem:"
                                            name="company_represented" size="col-md-6"
                                            type="text"></form-input>
                            </div>

                            <div class="mt-3">
                                <form-user-agreement-input v-model="privacy_agreeement" :error-messages="errorMessages"
                                                           :label="privacy_agreement_label"
                                                           :modelValue="privacy_agreeement"
                                                           :require="1"
                                                           name="privacy_agreeement"></form-user-agreement-input>
                                <form-user-agreement-input v-model="regulamin_agreement" :error-messages="errorMessages"
                                                           :modelValue="regulamin_agreement" :require="1"
                                                           label="Akceptuję <a target='_blank' href='/storage/Regulamin_Med_Space_Sp._k.pdf'>regulamin</a>"
                                                           name="regulamin_agreement"></form-user-agreement-input>
                                <form-user-agreement-input v-model="marketing_agreeement"
                                                           :error-messages="errorMessages"
                                                           :label="marketing_agreement_label"
                                                           :modelValue="marketing_agreeement" :require="0"
                                                           name="marketing_agreeement"></form-user-agreement-input>
                            </div>

                            <div v-if="errorMessages" class="alert alert-danger">
                                <p>
                                    Wystąpił błąd przetwarzania formularza, prosimy uzupełnić dane:
                                </p>

                                <ul>
                                    <li v-for="error in errorMessages" v-html="error[0]"></li>
                                </ul>
                            </div>

                            <div class="form-group text-center">
                                <button class="btn btn-primary btn-lg" type="submit">Załóż konto</button>
                            </div>

                            <div class="form-links">
                                <a href="/logowanie">Masz już konto? Zaloguj się</a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <notifications group="foo"/>

    </div>
</template>

<script>
import FormInput from "./formInput";
import FormSelect from "./formSelect";
import FormTextarea from "./formTextarea";
import Spinner from 'vue-simple-spinner';
import FormUserType from "./formUserType";
import FormAgreementInput from "./formAgreementInput";
import FormUserAgreementInput from "./formUserAgreementInput";

export default {
    props: ['agreement_inputs', 'professions', 'privacy_agreement_content', 'marketing_agreement_content', 'redirect_url'],

    components: {
        FormUserType,
        FormAgreementInput,
        FormInput,
        FormSelect,
        FormTextarea,
        FormUserAgreementInput,
        Spinner
    },
    data() {
        return {
            email: null,
            password: null,
            password_confirm: null,
            name: null,
            last_name: null,
            specialization: null,
            pwz_number: null,
            street: null,
            card: null,
            university: null,
            company_represented: null,
            user_type: 'person',
            work_place: null,
            agreements: [],
            errorMessages: null,
            successStatus: null,
            processing: false,
            profession: null,
            phone: null,
            specialAgreementInputs: [],
            privacy_agreeement: 0,
            regulamin_agreement: 0,
            marketing_agreeement: 0,
            privacy_agreement_label: this.privacy_agreement_content,
            marketing_agreement_label: this.marketing_agreement_content,
        }
    },

    methods: {
        handleRegisterForm() {
            axios.post('/api/register', {
                email: this.email,
                password: this.password,
                password_confirm: this.password_confirm,
                name: this.name,
                last_name: this.last_name,
                profession: this.profession,
                specialization: this.specialization,
                pwz_number: this.pwz_number,
                company_represented: this.company_represented,
                street: this.street,
                card: this.card,
                university: this.university,
                work_place: this.work_place,
                agreements: this.agreements,
                user_type: this.user_type,
                phone: this.phone,
                privacy_agreeement: this.privacy_agreeement,
                regulamin_agreement: this.regulamin_agreement,
                marketing_agreeement: this.marketing_agreeement,
            })
                .then(response => {
                    this.processing = true;
                })
                .then(response => {
                    this.processing = false;
                    window.location.href = '/' + this.redirect_url;
                })
                .catch(error => {
                    this.errorMessages = error.response.data.errors;
                    this.$notify({
                        'group': 'foo',
                        'type': 'error',
                        'title': error.response.data.message,
                    });
                }).then(error => {
                window.scrollTo(0, document.querySelector('.error').offsetParent.offsetTop);
            });
        },
    }

}
</script>
